import { defaultMarkdownParser } from 'prosemirror-markdown';
import { Node, Schema } from 'prosemirror-model';

export function docFromText(schema: Schema, text: string) {
  return Node.fromJSON(schema, defaultMarkdownParser.parse(text).toJSON());
}

export function textFromDoc(node: Node) {
  if (node.isText) {
    return node.textContent;
  }

  let res = '';
  node.content.forEach(child => {
    const text = textFromDoc(child);
    if (!text.length) {
      return;
    }

    if (child.isInline) {
      res += text;
    } else {
      if (res.length > 0) {
        res += '\n' + text;
      } else {
        res += text;
      }
    }
  });

  return res.trim();
}

export function docFromJsonString(schema: Schema, content: string) {
  let _content, doc;
  try {
    _content = JSON.parse(content);
  } catch {
    // noop
  }

  if (_content && _content.type === 'doc') {
    doc = Node.fromJSON(schema, _content);
  } else {
    doc = docFromText(schema, content);
  }

  return doc;
}

export function jsonStringFromDoc(node: Node) {
  return JSON.stringify(node.toJSON());
}
